var _metadata, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsNs1: "http://sozi.baierouge.fr",
    viewBox: "0 0 500 500",
    inkscapeVersion: "0.91 r13725",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#aaa",
    transform: "translate(151.625,1010.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.511-1010.2c-82.584,4.1917-154.6,48.523-196.98,113.89l85.781,49.607c24.978-35.605,65.228-59.679,111.23-62.677v-100.82c-0.01043,0.0005-0.02094-0.0006-0.03137,0z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "p1",
    attributeName: "fill",
    attributeType: "XML",
    from: "#333",
    to: "#aaa",
    dur: "0.08s",
    fill: "freeze",
    begin: "0s; p6.end"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m111.14-1010.2,0,101.35c44.506,4.7575,83.092,29.309,106.83,64.687l90.205-52.152c-42.394-65.388-114.42-109.72-197.04-113.89z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "p2",
    attributeName: "fill",
    attributeType: "XML",
    from: "#333",
    to: "#aaa",
    dur: "0.1s",
    fill: "freeze",
    begin: "p1.end"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-124.33-874.18c-17.473,34.173-27.297,72.92-27.297,113.95,0,41.029,9.8236,79.745,27.297,113.92l86.973-50.298c-9.6635-19.671-15.092-41.818-15.092-65.221,0-22.43,4.9773-43.692,13.899-62.74l-85.781-49.607z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "p6",
    attributeName: "fill",
    attributeType: "XML",
    from: "#333",
    to: "#aaa",
    dur: "0.2s",
    fill: "freeze",
    begin: "p5.end"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m321.05-874.18-90.675,52.403c8.12,18.323,12.644,38.606,12.644,59.943,0,22.317-4.9677,43.483-13.805,62.457l91.805,53.063c17.477-34.176,27.359-72.884,27.359-113.92,0-41.029-9.855-79.776-27.328-113.95z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "p3",
    attributeName: "fill",
    attributeType: "XML",
    from: "#333",
    to: "#aaa",
    dur: "0.2s",
    fill: "freeze",
    begin: "p2.end"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m216.44-677.17c-23.852,34.163-61.743,57.738-105.3,62.394v104.52c82.625-4.1631,154.64-48.496,197.04-113.89l-91.742-53.032z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "p4",
    attributeName: "fill",
    attributeType: "XML",
    from: "#333",
    to: "#aaa",
    dur: "0.08s",
    fill: "freeze",
    begin: "p3.end"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-24.084-674.65-87.381,50.518c42.379,65.37,114.4,109.7,197,113.88v-103.99c-45.02-2.9339-84.548-26.05-109.63-60.415z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "p5",
    attributeName: "fill",
    attributeType: "XML",
    from: "#333",
    to: "#aaa",
    dur: "0.1s",
    fill: "freeze",
    begin: "p4.end"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.9fb0c537437f84a251660f26e263f39b.svg";
export { ForwardRef as ReactComponent };